import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Loader } from '@thd-olt-component-react/core-ui';
import { LoadingButton, Typography, Link } from '@one-thd/sui-atomic-components';
import { PaintSwatches } from '@one-thd/sui-icons';

import { getCents, getDollars } from '../helpers';

const OrderSampleContent = ({
  children,
  dimensionText,
  handleClick,
  link,
  loading,
  multipleSamples,
  oosMessage,
  price,
  sampleAvailability,
  showTitle
}) => {
  const subtext = (!multipleSamples && !link)
    ? `Order a ${dimensionText} sample`
    : 'Order a sample';
  const samplesAreAvailable = sampleAvailability === 'Available';

  const defaultButtonText = multipleSamples ? 'Order Sample' : 'Add Sample to Cart';

  const priceElement = () => (
    <Typography component="span" variant="body-base" truncate>
      {
        price
          ? (
            <>
              {subtext + ' for '}
              {price < 1
                ? <Typography component="span" weight="bold">{getCents(price)}&cent;</Typography>
                : <Typography component="span" weight="bold">${getDollars(price)}</Typography>}
            </>
          )
          : <>{subtext}</>
      }
    </Typography>
  );

  const oosClasses = classnames('sui-flex sui-flex-col', {
    'sui-justify-center': samplesAreAvailable
  });

  return (
    <div className="sui-flex sui-flex-wrap sui-justify-between sui-bg-primary sui-gap-2 sui-items-center">
      <div className="sui-flex sui-flex-row sui-gap-2">
        <div className="sui-self-center">
          <PaintSwatches size="large" />
        </div>
        <div className={oosClasses}>
          {showTitle && (<Typography variant="h4" truncate>{children}</Typography>)}
          {samplesAreAvailable
            && (
              !link
                ? priceElement()
                : (
                  // eslint-disable-next-line
                  <Link
                    align="left"
                    component="button"
                    onClick={handleClick}
                  >
                    {
                      loading
                        ? <Loader active small />
                        : (priceElement())
                    }
                  </Link>
                )
            )}
          {oosMessage && !samplesAreAvailable
            && (<Typography color="inactive">{sampleAvailability}</Typography>)}
        </div>
      </div>
      {!link && (
        <LoadingButton
          variant="secondary"
          disabled={!samplesAreAvailable}
          onClick={handleClick}
          loading={loading}
        >
          {!samplesAreAvailable ? sampleAvailability : defaultButtonText}
        </LoadingButton>
      )}
    </div>
  );
};

OrderSampleContent.displayName = 'OrderSampleContent';

OrderSampleContent.propTypes = {
  children: PropTypes.node.isRequired,
  dimensionText: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  link: PropTypes.bool,
  loading: PropTypes.bool,
  multipleSamples: PropTypes.bool,
  oosMessage: PropTypes.bool,
  price: PropTypes.number,
  sampleAvailability: PropTypes.string,
  showTitle: PropTypes.bool.isRequired
};

OrderSampleContent.defaultProps = {
  link: false,
  loading: false,
  multipleSamples: false,
  oosMessage: false,
  price: NaN,
  sampleAvailability: 'Available'
};

export default OrderSampleContent;
